import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-v2': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_tai_chi_walking_fem_v2_adapted_copy_for_seniors~1
			funnel: {
				id: 'ob-female-tai-chi-walking-v2-copy-for-seniors',
				locale: ['en'],
			},
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_tai_chi_walking_fem_v2_adapted_copy_for_seniors~1&age=65
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_tai_chi_walking_fem_v2_adapted_copy_for_seniors'
					),
			},
		},
	},
]

export default config
